export const convertArrayToString = (
  array?: Array<any>,
): string | undefined => {
  if (!array) {
    return undefined;
  }
  return array.join(', ');
};
